import {
  AdditionalCost,
  Button,
  ContactCapital,
  FastLoanTenorInfo,
  MoreFAQ,
} from 'components/CapitalRevamp';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './FastLoanTenor.css';
import TenorTable from './Table/TenorTable';

class FastLoanTenor extends Component {
  state = {
    selectedTenor: {},
  };

  onSelectedTenorChange = value => {
    if (value) this.setState({ selectedTenor: value });
  };

  onSubmit = () => {
    const { onTenorSubmit } = this.props;
    const { selectedTenor } = this.state;
    selectedTenor.amount = selectedTenor.amount * 1000000;
    onTenorSubmit(selectedTenor);
  };

  render() {
    const { tenorData } = this.props;
    const { selectedTenor } = this.state;
    return (
      <div>
        <div className={styles['wrapper-main']}>
          <div className={styles['tenor-wrapper']}>
            <TenorTable
              data={tenorData}
              onTableChange={this.onSelectedTenorChange}
            />
            <div className={styles['tenor-submit']}>
              <Button
                disabled={!selectedTenor.amount || selectedTenor.amount < 10}
                title="Ajukan"
                onClick={this.onSubmit}
              />
            </div>
          </div>
          <div className={styles['additional-cost']}>
            <AdditionalCost />
          </div>
        </div>
        <div className={styles['wrapper-bottom']}>
          <div className={styles['content-bottom']}>
            <FastLoanTenorInfo />
          </div>
          <div className={styles['content-bottom']}>
            <ContactCapital title="Ada Pertanyaan? Hubungi Tim Moka Capital" />
          </div>
          <div className={styles['content-bottom']}>
            <MoreFAQ
              title="Butuh informasi lebih lanjut mengenai Fast Loan?"
              faqTitle="Baca FAQ Fast Loan"
              faqURL="http://info.mokapos.com/faq-commonwealth"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { tenorData } = state.capital.fastLoan;
  return {
    tenorData,
  };
}

export default connect(
  mapStateToProps,
  null
)(FastLoanTenor);
